<template>
  <div>
    <div>
      <HeaderOfPage :bgSrc="'banner-single-prog.jpg'" :titleOfPage="'اسم البرنامج'"/>
    </div>
    <div>
      <section class="pages-container single-prog-page">
        <b-container>
          <b-row>
            <b-col sm="9" class="tabs-side-container">
              <article>
                <h1 class=" h2">اليونان صيف 2020</h1>
                <b-tabs content-class="mt-3">
                   <b-tab title="المدن" active>
                     <b-row>
                       <b-col sm="8">
                          <h2>اليونان</h2>
                          <p>المناخ في اليونان يتوافق مع مناخ وسط البحر المتوسط، ففي فصل الشتاء يكون الجو مُعتدل ويُرافقه أمطار مُعتدله غير غزيرة، ويكون حاراً وجافاً في فصل الصيف حيث إن أشعة الشمس قوية، إلا أن مناخ العاصمة أثينا ومناطق شرق اليونان مختلفة غالباً، إذ إنه جاف وقليل الأمطار طوال العام، أما عن المناطق الجبلية فَهي مُعرّضة لأمطار غزيرة بالإضافة إلى أنها تَكتسي بالثلوج خلال فصل الشتاء</p>
                       </b-col>
                       <b-col sm="4" class="img-container">
                         <figure>
                           <img src="images/banners/single-page-prog.jpg" alt="program">
                           <figcaption>اليونان صيف 2020</figcaption>
                         </figure>
                       </b-col>
                     </b-row>
                   </b-tab>
                   <b-tab title="البرنامج يشمل">
                     <p>شامل - الافطار - الغذاء - العشاء - تذكرة الطيران الدولية ذهاب و عودة من مطار القاهرة - الانتقالات من والى المطار و مشرف مرافق المجموعة</p>
                   </b-tab>
                   <b-tab title="البرنامج لا يشمل">
                    <p>غير شامل الرحلات والانتقالات الداخلية</p>
                   </b-tab>
                   <b-tab title="الحجز">
                    <b-form @submit="onSubmit" @reset="onReset">
                     <b-row>
                       <b-col sm="6">
                         <b-form-group
                           id="input-group-1"
                           label="الاسم الأول"
                           label-for="input-1"
                         >
                           <b-form-input
                             id="input-1"
                             type="text"
                             v-model="bookForm.firstName"
                             required
                             placeholder="الاسم الأول"
                           ></b-form-input>
                         </b-form-group>
                       </b-col>
                       <b-col sm="6">
                         <b-form-group
                           id="input-group-2"
                           label="الاسم الثاني"
                           label-for="input-1"
                         >
                           <b-form-input
                             id="input-2"
                             type="text"
                             v-model="bookForm.lastName"
                             required
                             placeholder="الاسم الثاني"
                           ></b-form-input>
                         </b-form-group>
                       </b-col>
                       <b-col sm="6">
                         <b-form-group
                           id="input-group-3"
                           label="البريد الالكتروني"
                           label-for="input-1"
                         >
                           <b-form-input
                             id="input-3"
                             type="email"
                             v-model="bookForm.email"
                             required
                             placeholder="البريد الالكتروني"
                           ></b-form-input>
                         </b-form-group>
                       </b-col>
                       <b-col sm="6">
                         <b-form-group
                           id="input-group-4"
                           label="رقم الهاتف"
                           label-for="input-1"
                         >
                           <b-form-input
                             id="input-4"
                             type="text"
                             v-model="bookForm.phone"
                             required
                             placeholder="رقم الهاتف"
                           ></b-form-input>
                         </b-form-group>
                       </b-col>
                       <b-col sm="12">
                         <b-form-group
                           id="input-group-5"
                           label="رسالة"
                           label-for="input-1"
                         >
                         <b-form-textarea
                           id="input-group-5"
                           v-model="bookForm.message"
                           placeholder="رسالة"
                           rows="5"
                           max-rows="6"
                         ></b-form-textarea>
                         </b-form-group>
                       </b-col>
                       <b-col class="buttons-contain">
                         <b-button type="reset" variant="danger" class="reset">تفريغ</b-button>
                         <b-button type="submit" variant="primary" class="send">ارسال</b-button>
                       </b-col>
                     </b-row>
                    </b-form>
                   </b-tab>
                 </b-tabs>
               </article>
               <div class="social-media-container">
                 <social-sharing :url="'http://localhost:8080/#/blog/' + 'routename'"
                                      title="نصائح تفيدك اذا كنت من هواة تسلق الجبال"
                                      description=""
                                      quote=""
                                      hashtags="نصائح_حول_السفر"
                                      twitter-user=""
                                      inline-template>
                  <div>
                      <network network="email" class="email">
                          <i class="far fa-envelope"></i>

                      </network>

                      <network network="facebook" class="facebook">
                        <i class="fab fa-facebook-square"></i>
                      </network>

                      <network network="linkedin" class="linkedin">
                        <i class="fab fa-linkedin"></i>
                      </network>

                      <network network="pinterest" class="pinterest">
                        <i class="fab fa-pinterest-square"></i>
                      </network>

                      <network network="sms">
                        <i class="fas fa-sms"></i>
                      </network>

                      <network network="twitter" class="twitter">
                        <i class="fab fa-twitter-square"></i>
                      </network>
                      <network network="whatsapp" class="whatsapp">
                        <i class="fab fa-whatsapp-square"></i>
                      </network>
                  </div>
                </social-sharing>
               </div>
            </b-col>
            <b-col sm="3">
                <AsideBlog/>
            </b-col>
          </b-row>
        </b-container>
      </section>
    </div>
  </div>

</template>
<script type="text/javascript">
  import HeaderOfPage from '../global/HeaderOfPage'
  import AsideBlog    from '../blog/AsideBlog'

  import Vue from 'vue'
  var SocialSharing = require('vue-social-sharing');
  Vue.use(SocialSharing);


  export default {
    name:'SingleProgramPage',
    components: {
      HeaderOfPage,
      AsideBlog
    },
    data() {
      return {
        bookForm: {
          firstName: '',
          lastName: '',
          email:'',
          phone:'',
          message:''
        }
      }
    },
    methods: {
      //send booking form
      onSubmit() {
        console.log('form submited')
      },
      //reset Form
      onReset() {
        this.firstName = '',
        this.lastName  = '',
        this.email     = '',
        this.phone     = '',
        this.message   = ''
      }
    }
  }
</script>
